export default "__VITE_ASSET__aa40c6f4__"